"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var navFontSize = exports.navFontSize = {
  type: "select",
  options: [{ label: "8", value: "8px" }, { label: "12", value: "12px" }, { label: "13", value: "13px" }, { label: "14", value: "14px" }, { label: "16", value: "16px" }, { label: "18", value: "18px" }, { label: "20", value: "20px" }, { label: "22", value: "22px" }, { label: "24", value: "24px" }, { label: "26", value: "26px" }, { label: "28", value: "28px" }]
};

var linkTextTransform = exports.linkTextTransform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "lowercase", value: "lowercase" }]
};

var linkFontWeight = exports.linkFontWeight = {
  type: "select",
  options: [{ label: "Light", value: "300" }, { label: "Normal", value: "400" }, { label: "Medium", value: "500" }, { label: "Bold", value: "600" }]
};